/**
 * cart-discount.js  v3
 * AJAX discount apply/remove + auto-clear when cart is emptied.
 */
(function () {
  'use strict';

  if (window.customElements.get('cart-discount')) return;

  /* ──────────────────────────────────────────────────────────────────────────
     CART DISCOUNT ELEMENT — apply / remove codes via AJAX
  ─────────────────────────────────────────────────────────────────────────── */
  class CartDiscount extends HTMLElement {
    constructor() {
      super();
      this._apply   = this._apply.bind(this);
      this._remove  = this._remove.bind(this);
      this._keydown = this._keydown.bind(this);
    }

    connectedCallback() {
      var applyBtn = this.querySelector('[data-cart-discount-apply]');
      if (applyBtn) applyBtn.addEventListener('click', this._apply);

      var inp = this.querySelector('[data-cart-discount-input]');
      if (inp) inp.addEventListener('keydown', this._keydown);

      this.addEventListener('click', (e) => {
        var btn = e.target.closest('[data-cart-discount-remove]');
        if (btn) this._remove(btn);
      });
    }

    _keydown(e) {
      if (e.key === 'Enter') { e.preventDefault(); this._apply(); }
    }

    _msg(text, kind) {
      var el = this.querySelector('[data-cart-discount-message]');
      if (!el) return;
      el.textContent = text || '';
      el.classList.remove('cart-discount__message--error', 'cart-discount__message--success');
      if (kind === 'error')   el.classList.add('cart-discount__message--error');
      if (kind === 'success') el.classList.add('cart-discount__message--success');
    }

    _busy(on) {
      var btn = this.querySelector('[data-cart-discount-apply]');
      if (!btn) return;
      btn.disabled = on;
      if (on) { btn._orig = btn.textContent; btn.textContent = 'Applying\u2026'; }
      else    { if (btn._orig) btn.textContent = btn._orig; }
    }

    _apply() {
      var inp  = this.querySelector('[data-cart-discount-input]');
      var code = inp ? inp.value.trim() : '';
      if (!code) { this._msg('Please enter a discount code.', 'error'); return; }

      this._busy(true); this._msg('', null);

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code })
      })
        .then((r) => r.json())
        .then(() => fetch('/cart.js', { headers: { Accept: 'application/json' } }))
        .then((r) => r.json())
        .then((cart) => {
          var codes = (cart.discount_codes || []).map((c) => ({
            code: c.code.toLowerCase(), ok: c.applicable
          }));
          var match = codes.find((c) => c.code === code.toLowerCase());
          if (!match)     { this._msg('Code could not be applied.', 'error'); this._busy(false); return; }
          if (!match.ok)  { this._msg('Code is not valid for this cart.', 'error'); this._busy(false); return; }
          this._msg('Discount applied!', 'success');
          if (inp) inp.value = '';
          this._refresh().then(() => this._busy(false));
        })
        .catch(() => { this._msg('Something went wrong. Please try again.', 'error'); this._busy(false); });
    }

    _remove(btn) {
      var code = btn.getAttribute('data-discount-code') || '';
      var remaining = [];
      this.querySelectorAll('[data-cart-discount-remove]').forEach((b) => {
        var c = b.getAttribute('data-discount-code');
        if (c && c !== code) remaining.push(c);
      });
      this._msg('', null);
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: remaining.join(',') })
      })
        .then((r) => r.json())
        .then(() => this._refresh())
        .catch(() => this._msg('Could not remove. Please refresh.', 'error'));
    }

    _refresh() {
      return fetch(window.location.pathname, { headers: { Accept: 'text/html' } })
        .then((r) => r.text())
        .then((html) => {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          ['main-cart-items', 'main-cart-footer'].forEach((id) => {
            var src = tmp.querySelector('#' + id), dst = document.getElementById(id);
            if (src && dst) dst.innerHTML = src.innerHTML;
          });
          var bSrc = tmp.querySelector('#cart-icon-bubble'), bDst = document.getElementById('cart-icon-bubble');
          if (bSrc && bDst) bDst.innerHTML = bSrc.innerHTML;
          if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
            try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount' }); } catch (e) {}
          }
        });
    }
  }

  window.customElements.define('cart-discount', CartDiscount);

  /* ──────────────────────────────────────────────────────────────────────────
     AUTO-CLEAR DISCOUNT WHEN CART IS EMPTIED
     Fires on: remove-button clicks, cart PubSub updates, page load, qty=0 edits
  ─────────────────────────────────────────────────────────────────────────── */
  (function () {
    var _busy = false;

    function nukeDiscount() {
      if (_busy) return;
      _busy = true;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: '' })
      })
        .then((r) => r.json())
        .then(() => {
          _busy = false;
          // Immediately wipe any displayed codes in DOM
          wipeDomDiscounts();
          // Re-render cart page sections so server-side discount display is gone
          if (document.getElementById('main-cart-footer')) {
            fetch(window.location.pathname, { headers: { Accept: 'text/html' } })
              .then((r) => r.text())
              .then((html) => {
                var tmp = document.createElement('div');
                tmp.innerHTML = html;
                ['main-cart-items', 'main-cart-footer'].forEach((id) => {
                  var src = tmp.querySelector('#' + id), dst = document.getElementById(id);
                  if (src && dst) dst.innerHTML = src.innerHTML;
                });
              }).catch(() => {});
          }
        })
        .catch(() => { _busy = false; });
    }

    function wipeDomDiscounts() {
      document.querySelectorAll(
        '[data-cart-discount-applied], .cart-discount__applied-list, ' +
        '.cart-drawer__footer .discounts'
      ).forEach((el) => { el.innerHTML = ''; });
    }

    function check() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          if (cart.item_count === 0) {
            wipeDomDiscounts();
            if (cart.discount_codes && cart.discount_codes.length) nukeDiscount();
          }
        }).catch(() => {});
    }

    // ── Hooks ────────────────────────────────────────────────────────────────

    // 1. Remove button clicks
    document.addEventListener('click', (e) => {
      if (e.target.closest('cart-remove-button')) {
        setTimeout(check, 700);
        setTimeout(check, 1500);
      }
    });

    // 2. PubSub cartUpdate
    (function hookPS() {
      if (window.PUB_SUB_EVENTS && typeof subscribe === 'function') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (evt) => {
          if (evt && evt.source === 'cart-discount') return;
          setTimeout(check, 500);
        });
      } else { setTimeout(hookPS, 400); }
    })();

    // 3. Quantity input set to 0
    document.addEventListener('change', (e) => {
      if (e.target.closest('.quantity__input') && parseInt(e.target.value, 10) === 0) {
        setTimeout(check, 1200);
      }
    });

    // 4. Page load — catch stale discounts
    function onLoad() {
      if (
        window.location.pathname.indexOf('/cart') !== -1 ||
        document.querySelector('cart-items') ||
        document.getElementById('main-cart-footer')
      ) { check(); }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onLoad);
    else onLoad();
  })();

})();
